import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// トスアップ情報項目削除
export async function deleteTossUpTossUpInfo(id: string, key: string) {
  try {
    const response = await axios.delete(
      CONST.apiUrl + "tossUpTossUpInfo" + "?id=" + encodeURIComponent(id) + "&key=" + encodeURIComponent(key)
    );
    return response.data.delete;
  } catch (error) {
    logout();
  }
}

// トスアップ情報一覧
export async function getTossUpTossUpInfos(id: string) {
  try {
    const path = "tossUpTossUpInfos";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    const option_data: {
      [key: string]: string | number;
    }[] = response.data.option_data;
    return { sudDatas: response.data.fetch_data, option_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}
